/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function productLines(instance) {
	return {
		/**
		 * @param {number} brandId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (brandId, config = {}) => {
			return instance.get(`product_lines/${brandId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`product_lines${params}`, config)
		},

		/**
		 * @param {number} id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (id, body, config = {}) => {
			return instance.put(`product_lines/${id}`, body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`product_lines/${id}`, config)
		},

		/**
		 * @param {{ name: string, code: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('product_lines', body, config)
		}
	}
}
